import { AmplySearchData, DoubleTheDonationSearchData } from 'pages/api/employer-match/amply'
import { api } from '../api'

export enum EmployerMatchTypes {
  DOUBLE_THE_DONATION = 'DTD',
  AMPLY = 'AMPLY',
}

type EmployerMatchSearchParams = {
  companySearchString: string
  type: EmployerMatchTypes
}

const employerMatchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchEmployerMatchCompanies: builder.query<
      AmplySearchData | DoubleTheDonationSearchData,
      EmployerMatchSearchParams
    >({
      query: ({ companySearchString, type }) => ({
        url: `/employer-match/${type.toLowerCase()}?companySearchString=${encodeURIComponent(
          companySearchString,
        )}`,
      }),
    }),
  }),
})

export const {
  endpoints: { searchEmployerMatchCompanies },
  useSearchEmployerMatchCompaniesQuery,
} = employerMatchApi

export default employerMatchApi
